import React from 'react';
import MagicForm from '../../Form/MagicForm';
import { ItemScheme } from '../../Form/MagicFormItem';

interface Props {
	onSubmit: (values: any) => void;
	formScheme: ItemScheme[];
	defaultValues: object;
}
const SideFilterForm: React.FC<Props> = props => (
	<MagicForm {...props} submitText='nczi.action.confirm' />
);

export default SideFilterForm;
